var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.005,
    height: 22,
    viewBox: "0 0 22.005 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-instagram",
    "data-name": "Icon awesome-instagram",
    d: "M11,7.6a5.641,5.641,0,1,0,5.641,5.641A5.632,5.632,0,0,0,11,7.6ZM11,16.9a3.667,3.667,0,1,1,3.667-3.667A3.674,3.674,0,0,1,11,16.9Zm7.187-9.538a1.316,1.316,0,1,1-1.316-1.316A1.313,1.313,0,0,1,18.187,7.366ZM21.923,8.7a6.511,6.511,0,0,0-1.777-4.61,6.554,6.554,0,0,0-4.61-1.777c-1.816-.1-7.261-.1-9.077,0a6.544,6.544,0,0,0-4.61,1.772A6.532,6.532,0,0,0,.072,8.7c-.1,1.816-.1,7.261,0,9.077a6.511,6.511,0,0,0,1.777,4.61,6.562,6.562,0,0,0,4.61,1.777c1.816.1,7.261.1,9.077,0a6.511,6.511,0,0,0,4.61-1.777,6.554,6.554,0,0,0,1.777-4.61c.1-1.816.1-7.256,0-9.072ZM19.576,19.723a3.713,3.713,0,0,1-2.091,2.091c-1.448.574-4.885.442-6.485.442s-5.042.128-6.485-.442a3.713,3.713,0,0,1-2.091-2.091c-.574-1.448-.442-4.885-.442-6.485S1.854,8.2,2.424,6.753A3.713,3.713,0,0,1,4.515,4.662C5.963,4.087,9.4,4.22,11,4.22s5.042-.128,6.485.442a3.713,3.713,0,0,1,2.091,2.091c.574,1.448.442,4.885.442,6.485S20.15,18.279,19.576,19.723Z",
    transform: "translate(0.005 -2.238)",
    fill: "#ffd536"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.16f5bf068fc2e64c2fcc3d583422bc02.svg";
export { ForwardRef as ReactComponent };